import { useState } from 'react';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import ActiveRequestsTableApp from '../../Visitor/Functionality/ActiveRequestsTableApp';
import RequestAccessModal from '../../Visitor/Modal/RequestAccessModal';
import ActiveRequestsTable from '../../Visitor/SubComponents/ActiveRequestsTable';
import { RequestTabApp } from '../Functionality/RequestTabApp';
import AssingHostModal from '../Modal/AssingHostModal';
import RejectRequestModal from '../Modal/RejectRequestModal';
import { MODAL_OPTIONS } from '../Model/Model';
import { TABLES } from '../../../../../Apis/Tables';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */


const RequestTab = () => {

    const [searchElement, setSearchElement] = useState('')
    const [search, setSearch] = useState(false)
    const optionTable = TABLES.REQUEST_ACCESS
    const [modified, setModified] = useState(false)
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag

    const {
        t,
        results,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        detailsModal,
        itemSelected,
        handleCloseDetails,
        setDetailsModal
    } = ActiveRequestsTableApp({
        searchElement,
        setSearch,
        optionTable,
        modified,
        setModified,
        setIsAllChecked
    })

    const {
        isHostModal,
        handleCloseModalHost,
        handleOpenModalHost,
        selectedHost,
        setSelectedHost,
        cleanChipSearchHost,
        setCleanChipSearchHost,
        isReject,
        openRejectModal,
        closeRejectModal,
        data,
        handleChange,
        handleAction,
        emptyFields,
        hasPermissions
    } = RequestTabApp({
        setDetailsModal,
        itemSelected,
        setModified
    });

    return (
        <>
            <div className={"col-12 p-0"}>
                <SearchSimple
                    id={searchId}
                    setBodyForExport={() => { }}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={optionTable}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={null}
                    supplierId={null}
                />
            </div>
            <div className='col-12 p-0'>
                <ActiveRequestsTable
                    t={t}
                    pagination={pagination}
                    tableId={tableId}
                    searchId={searchId}
                    thead={thead}
                    tbody={tbody}
                    getActionsButtons={getActionsButtons}
                />
            </div>

            <RequestAccessModal
                show={detailsModal}
                onClose={handleCloseDetails}
                onHide={openRejectModal}
                onConfirm={handleOpenModalHost}
                itemSelected={itemSelected}
                confirmButton={hasPermissions}
                cancelButton={hasPermissions}
                buttonConfirm="assign_host"
                buttonCancelText={t('reject')}
                optionTable={optionTable}
                cancelClass="btn-color-error-600-800"
            />

            <AssingHostModal
                show={isHostModal}
                onHide={handleCloseModalHost}
                onConfirm={() => handleAction(MODAL_OPTIONS.ASSIGN)}
                selectedHost={selectedHost}
                setSelectedHost={setSelectedHost}
                cleanChipSearchHost={cleanChipSearchHost}
                setCleanChipSearchHost={setCleanChipSearchHost}
                handleAssignHost={() => handleAction(MODAL_OPTIONS.ASSIGN)}
                emptyFields={emptyFields}
            />

            <RejectRequestModal
                show={isReject}
                onConfirm={() => handleAction(MODAL_OPTIONS.REJECT)}
                onHide={closeRejectModal}
                data={data}
                handleChange={handleChange}
                emptyFields={emptyFields}
            />
        </>
    );
};

export default RequestTab;
